import { app } from '../../../core/App';
import { Sounds } from '../../../sounds';
import CharacterSpine, { CharacterAnimation } from '../CharacterSpine';
import { EquipmentType } from '../VehicleEquipment';
import { VehicleEquipmentMeleeWeapon } from '../VehicleEquipmentMeleeWeapon';
import { VehicleVillain } from '../VehicleVillain';
import { SpineEvents } from '../../../core/enums/SpineEvents';
import { BodyTypes } from '../../LevelManager';

export class VehicleWeaponShockWave extends VehicleEquipmentMeleeWeapon {
  constructor(scene: Phaser.Scene, vehicle: VehicleVillain, camera: Phaser.Cameras.Scene2D.Camera, spine: CharacterSpine) {
    super(scene, EquipmentType.GiantMallet, vehicle, camera, spine, 'shockwave', CharacterAnimation.Weapon);
  }

  public fire(): void {
    //app.audioHandler.playSound(this.scene, Sounds.Track.JestahPreFire1, Sounds.Channel.SFX, { volume: 1.0 });
    this.vehicle.CharacterSpine.fireEquipment();
  }

  public onFinishedFiring() {
    this.emit(VehicleWeaponShockWave.events.FinishedFiring);
  }

  public onHit(): void {}

  protected override makeHitbox(): MatterJS.BodyType {
    return this.scene.matter.add.rectangle(0, 0, 260, 100, {
      label: BodyTypes.Weapon,
      isSensor: true
    });
  }

  protected onFire() {
    this.emit(VehicleWeaponShockWave.events.Firing);
  }

  protected override animationStart(entry: spine.TrackEntry) {
    if (entry.animation.name == CharacterAnimation.Warning) {
      this.onFire();
      this.spine.on(SpineEvents.Event, this.animationEvent, this);
      console.log('ANIMATION STARTED', this.scene.sys.game.loop.getDurationMS());
    }

    // super.animationStart(entry);
  }

  protected animationEvent(entry: spine.TrackEntry, event: spine.Event) {
    console.log('ANIMATION EVENT! ', event.data.name, event.stringValue, this.scene.sys.game.loop.getDurationMS());

    if (event.data.name == 'hammer' && event.stringValue == 'start') {
      app.audioHandler.playSound(this.scene, Sounds.Track.JestahFire1, Sounds.Channel.SFX, { volume: 1.0 });
      // this.hitbox.position.y = this.vehicle.y - 36;
      this.scene.matter.body.setPosition(this.hitbox, { x: this.hitbox.position.x, y: this.vehicle.y - 36 });
      this.scene.matter.body.setVelocity(this.hitbox, { x: 0, y: 0 });
      this.toggleCollideY(true);
    }

    if (event.data.name == 'hammer' && event.stringValue == 'end') {
      this.toggleCollideY(false);
    }

    if (event.data.name == 'hammer-in') {
      app.audioHandler.playSound(this.scene, Sounds.Track.JestahFire1, Sounds.Channel.SFX, { volume: 1.0 });
      // this.toggleCollide(false);
      // this.onFinishedFiring();
    }
  }

  protected override animationEnd(entry: spine.TrackEntry) {
    if (entry.animation.name == CharacterAnimation.Weapon) {
      this.onFinishedFiring();
      console.log('ANIMATION ENDED');
      this.spine.off(SpineEvents.Event, this.animationEvent, this);
    }

    // super.animationEnd(entry);
  }
}
